import "core-js/modules/es7.array.includes.js";
import MdmIcon from '~/components/atoms/Global/MdmIcon.vue';
var MdmLink = () => import('~/components/atoms/MdmLink.vue');
export default {
  name: 'IconTextLink',
  components: {
    MdmIcon,
    MdmLink
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    },
    isPreventDefaultLink: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    to: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'light',
      validator(value) {
        return ['dark', 'light'].includes(value);
      }
    }
  },
  computed: {
    themeClass() {
      return this.theme === 'light' ? 'theme-light' : 'theme-dark';
    }
  }
};